/// <amd-module name="Repos/Views/Settings/Repositories/Components/RepositoryDialog" />
import React = require("react");
import { TextboxDialog } from "Repos/Views/Settings/Repositories/Components/TextboxDialog";
import { DialogType, IRepository } from "Repos/Views/Settings/Repositories/Contracts/Contracts";
import { IRepositoriesViewService } from "Repos/Views/Settings/Repositories/Services/RepositoriesViewService";
import { IObservableValue, IReadonlyObservableValue, ObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Observer } from "VSSUI/Observer";

interface IRepositoryDialogProps {
    dialogType: DialogType;
    message: string;
    primaryButtonDanger?: boolean;
    primaryButtonText: string;
    textBoxInitialValue: string;
    textboxPlaceholder?: string;
    title: string;
    getActionPromise(textboxValue: string): Promise<any>;
    primaryButtonDisabled(textBoxValue: string): boolean;
}

export class RepositoryDialog extends VssComponent<IRepositoryDialogProps> {
    private errorMessage: IObservableValue<string>;
    private isLoading: IObservableValue<boolean>;
    private repository: IReadonlyObservableValue<IRepository | undefined>;
    private showError: IObservableValue<boolean>;
    private shownDialogType: IReadonlyObservableValue<DialogType>;
    private svc: IRepositoriesViewService;

    public constructor(props: IRepositoryDialogProps, context: IVssComponentContext) {
        super(props, context);
        this.svc = context.pageContext.getService<IRepositoriesViewService>("RepositoriesViewService");

        this.isLoading = new ObservableValue<boolean>(false);
        this.showError = new ObservableValue<boolean>(false);
        this.errorMessage = new ObservableValue<string>("");

        this.shownDialogType = this.svc.getShownDialogType();
        this.repository = this.svc.getDialogRepository();
    }

    public render = (): JSX.Element => {
        return (
            <Observer repo={this.repository} shownDialogType={this.shownDialogType}>
                {(props: { repo: IRepository | undefined; shownDialogType: DialogType }) => {
                    return props.repo && props.shownDialogType === this.props.dialogType ? (
                        <TextboxDialog
                            errorMessage={this.errorMessage}
                            isLoading={this.isLoading}
                            message={this.props.message}
                            onCancel={this.onCancel}
                            onClick={this.onClick}
                            primaryButtonDanger={this.props.primaryButtonDanger}
                            primaryButtonDisabled={this.props.primaryButtonDisabled}
                            primaryButtonText={this.props.primaryButtonText}
                            textboxInitialValue={this.props.textBoxInitialValue}
                            textboxPlaceholder={this.props.textboxPlaceholder}
                            title={this.props.title}
                            showError={this.showError}
                        />
                    ) : null;
                }}
            </Observer>
        );
    };

    private onCancel = () => {
        this.isLoading.value = false;
        this.errorMessage.value = "";
        this.showError.value = false;
        this.svc.showDialog(DialogType.None);
    };

    private onClick = (event: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>, textboxValue: string) => {
        if (this.repository.value && textboxValue) {
            this.isLoading.value = true;
            this.props.getActionPromise(textboxValue).then(
                () => {
                    this.onCancel();
                },
                (reason: any) => {
                    this.errorMessage.value = reason.toString();
                    this.showError.value = true;
                    this.isLoading.value = false;
                }
            );
        }
    };
}
